<template>
  <v-row class="mt-5">
    <v-col cols="12">
      <v-text-field
        v-mask="'(##) #####-####'"
        :value="solicitanteTelefone"
        dense
        outlined
        readonly
        label="Telefone:"
        :prepend-icon="icons.mdiPhone"
      />
    </v-col>

    <v-col cols="12">
      <v-text-field
        :value="solicitanteEmail"
        dense
        outlined
        readonly
        label="E-mail:"
        :prepend-icon="icons.mdiEmail"
      />
    </v-col>
  </v-row>
</template>

<script>
import { mdiPhone, mdiEmail } from '@mdi/js'

export default {
  props: {
    solicitanteTelefone: {
      type: String,
      default: null,
    },
    solicitanteEmail: {
      type: String,
      default: null,
    },
  },

  setup() {
    return {
      icons: {
        mdiPhone,
        mdiEmail,
      },
    }
  },
}
</script>
